Action = require 'models/action'
ActionList = require 'models/collections/action-list'
ActionListView = require 'views/action/action-list-view'
Payloads = require 'network/payloads'
ViewWithActions = require 'views/internal/view-with-actions'
View = require 'view'
mixin = require 'lib/mixin'
templates = require 'views/internal/templates'

module.exports = mixin ViewWithActions, class MemberBoardProfileView extends View

  events:
    'click .js-more-actions': 'loadMoreActions'

  initialize: ->
    @board = @options.board
    @listenTo @board.memberList, 'add remove reset', @frameDebounce @render

    @actionListView = @collectionSubview ActionListView, new ActionList(@model.getActions(@board), { @modelCache }),
      renderOpts:
        context: @model
        readOnly: true

    @listenTo @modelCache, "add:Action:#{@model.id} remove:Action:#{@model.id}", =>
      @actionListView.collection.reset(@model.getActions(@board), silent: true)
      @renderActions()

    @idModels = [@board.id]
    @nextPage = 0
    @loadMoreActions()

  render: ->
    @$el.html(templates.fill('board_member_profile', @model.toJSON()))
    @actionListView.setElement @$('.list-actions')[0]
    @renderActions()

  renderActions: ->
    @actionListView.render()
    @$('.js-more-actions').toggle(@hasMoreActions())
    @

  getActionsFilter: ->
    Payloads.memberActions



// WEBPACK FOOTER //
// ./app/scripts/views/member/member-board-profile-view.coffee